import { Box, Container, Typography } from "@mui/material";
import { useWhitelabelStore } from "src/store/whitelabel/whitelabel.store";
import { usePublicRanking } from "../hooks/use-public-ranking";
import { useConfetti } from "../hooks/use-confetti";
import RankingContent from "./ranking-content";
import { useSettingsContext } from "src/components/settings";

// ----------------------------------------------------------------------

export default function PublicRankingView() {
  const settings = useSettingsContext();
  const { rankedSellers, rankedPositions, loading } = usePublicRanking();
  const whitelabel = useWhitelabelStore((state) => state.whitelabel);

  // Confetes - SOMENTE na URL "/dashboard/ranking"
  useConfetti(500);

  return (
    <Container maxWidth={settings.themeStretch ? false : "lg"} sx={{ py: 4 }}>
      {/* Logo whitelabel fixo no canto superior esquerdo */}
      {whitelabel?.logo && (
        <Box
          component="img"
          src={whitelabel.logo}
          alt={whitelabel.name}
          sx={{
            top: 16,
            left: 16,
            height: 54,
            width: "auto",
            objectFit: "contain",
            zIndex: 1300,
            pointerEvents: "none",
            mb: 4,
          }}
        />
      )}

      <RankingContent
        rankedSellers={rankedSellers}
        rankedPositions={rankedPositions}
        loading={loading}
        maxWidth={settings.themeStretch ? false : "lg"}
      />
    </Container>
  );
}
